import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import SlideVerify from "vue-monoplasty-slide-verify";
import VueSignaturePad from "vue-signature-pad";
import * as VueGoogleMaps from "vue2-google-maps";
Vue.filter("category", function (value) {
  switch (value) {
    case "Adult meal":
      return "成人套餐";
      break;
    case "Kids meal":
      return "儿童套餐";
      break;
    case "Sides":
      return "边菜";
      break;
    case "Drinks":
      return "酒水";
      break;
    case "Service":
      return "服务";
      break;
    case "Base & Add - ons":
      return "其他";
      break;
    default:
      return "-";
      break;
  }
});
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyCvcNeJgHXrai6i3IrNVCU2lr4dQI691Xg",
    libraries: "places", // 需要 places 库来实现搜索功能
  },
});

Vue.directive("number-only", {
  bind(el) {
    const input = el.tagName === "INPUT" ? el : el.querySelector("input");
    if (!input) return;

    // 标记：是否处于输入法组合输入状态
    let isComposing = false;

    const handleInput = (e) => {
      // 关键：输入法组合过程中，跳过过滤逻辑，避免干扰中文输入中间态
      if (isComposing) return;

      const newValue = e.target.value.replace(/\D/g, ""); // 只保留数字

      // 如果输入的值发生变化，更新并触发 v-model
      if (e.target.value !== newValue) {
        // 先缓存光标位置，避免更新值后光标跳到末尾（优化体验）
        const cursorPos = input.selectionStart;
        e.target.value = newValue;
        // 恢复光标位置
        input.selectionStart = input.selectionEnd = cursorPos;
        // 触发 input 事件，确保 v-model 同步
        input.dispatchEvent(new Event("input", { bubbles: true }));
      }
    };

    // 监听输入法组合开始：标记为组合中
    input.addEventListener("compositionstart", () => {
      isComposing = true;
    });

    // 监听输入法组合结束：标记为组合结束，并立即执行一次过滤
    input.addEventListener("compositionend", () => {
      isComposing = false;
      handleInput({ target: input }); // 组合结束后，强制过滤一次
    });

    input.addEventListener("input", handleInput);

    // 处理粘贴事件（防止粘贴非法字符）
    input.addEventListener("paste", (e) => {
      e.preventDefault();
      const pasteData = e.clipboardData.getData("text/plain");
      const filteredValue = pasteData.replace(/\D/g, "");
      // 替换 document.execCommand（已废弃），使用更现代的方式插入内容
      const cursorPos = input.selectionStart;
      const currentValue = input.value;
      // 插入过滤后的粘贴内容
      input.value = currentValue.slice(0, cursorPos) + filteredValue + currentValue.slice(input.selectionEnd);
      // 调整光标位置
      input.selectionStart = input.selectionEnd = cursorPos + filteredValue.length;
      // 触发 input 事件同步 v-model
      input.dispatchEvent(new Event("input", { bubbles: true }));
    });

    // 存储处理器和输入框引用，方便销毁
    el._numberOnly = {
      handleInput,
      input
    };
  },
  unbind(el) {
    const { handleInput, input } = el._numberOnly || {};
    if (input && handleInput) {
      input.removeEventListener("input", handleInput);
      // 移除组合事件监听，避免内存泄漏
      input.removeEventListener("compositionstart", () => { });
      input.removeEventListener("compositionend", () => { });
      input.removeEventListener("paste", () => { });
    }
    // 清理缓存
    delete el._numberOnly;
  },
});
Vue.directive("number-only2", {
  bind(el) {
    const input = el.querySelector("input");
    if (!input) return;

    // 标记：是否处于输入法组合输入状态（解决中文输入问题的核心）
    let isComposing = false;

    const handleInput = (e) => {
      // 关键：输入法组合过程中，跳过过滤逻辑，避免干扰中文输入中间态
      if (isComposing) return;

      // 允许数字和小数点，限制只能有一个小数点
      let newValue = e.target.value
        .replace(/[^\d.]/g, "") // 只保留数字和小数点
        .replace(/(\..*)\./g, "$1"); // 过滤多余的小数点，只保留第一个

      // 优化：如果输入的是 ".123"，自动补全为 "0.123"
      if (newValue.startsWith(".")) {
        newValue = "0" + newValue;
      }

      // 优化：处理 "000123" 这种前置多个0的情况（可选，根据需求保留/删除）
      // 若需要保留前置0，可注释以下代码块
      if (newValue.includes(".")) {
        // 有小数点时，仅去除整数部分的前置多余0（如 0012.34 → 012.34 不处理，000.12 → 0.12）
        const [integerPart, decimalPart] = newValue.split(".");
        const trimmedInteger = integerPart.replace(/^0+(?=\d)/, "");
        newValue = (trimmedInteger || "0") + "." + decimalPart;
      } else {
        // 无小数点时，去除前置多余0（如 000123 → 123，0000 → 0）
        newValue = newValue.replace(/^0+(?=\d)/, "");
        // 处理空值情况，确保至少保留一个0
        if (newValue === "") {
          newValue = "0";
        }
      }

      // 如果输入的值发生变化，更新并触发 v-model 同步
      if (e.target.value !== newValue) {
        // 缓存光标位置，避免更新值后光标跳到末尾（优化用户体验）
        const cursorPos = input.selectionStart;
        e.target.value = newValue;
        // 恢复光标位置
        input.selectionStart = input.selectionEnd = cursorPos;
        // 触发 input 事件，添加 bubbles: true 确保 Vue v-model 能捕获到
        input.dispatchEvent(new Event("input", { bubbles: true }));
      }
    };

    // 监听输入法组合开始：标记为组合中，跳过过滤
    input.addEventListener("compositionstart", () => {
      isComposing = true;
    });

    // 监听输入法组合结束：标记为组合结束，并强制执行一次过滤
    input.addEventListener("compositionend", () => {
      isComposing = false;
      handleInput({ target: input }); // 组合结束后，强制过滤格式化
    });

    // 绑定 input 事件
    input.addEventListener("input", handleInput);

    // 处理粘贴事件（防止粘贴非法字符，替换废弃 API）
    input.addEventListener("paste", (e) => {
      e.preventDefault();
      const pasteData = e.clipboardData.getData("text/plain");
      // 过滤粘贴内容：仅保留数字和单个小数点
      let filteredValue = pasteData
        .replace(/[^\d.]/g, "")
        .replace(/(\..*)\./g, "$1");
      // 补全前置 0（如粘贴 ".456" → "0.456"）
      if (filteredValue.startsWith(".")) {
        filteredValue = "0" + filteredValue;
      }

      // 替换废弃的 document.execCommand，使用现代方式插入内容
      const cursorPos = input.selectionStart;
      const currentValue = input.value;
      // 插入过滤后的内容到光标位置
      input.value = currentValue.slice(0, cursorPos) + filteredValue + currentValue.slice(input.selectionEnd);
      // 调整光标位置到粘贴内容末尾
      input.selectionStart = input.selectionEnd = cursorPos + filteredValue.length;
      // 触发 input 事件，确保 v-model 同步
      input.dispatchEvent(new Event("input", { bubbles: true }));
    });

    // 存储处理器和输入框引用，方便销毁
    el._numberOnly2 = {
      handleInput,
      input
    };
  },
  unbind(el) {
    const { handleInput, input } = el._numberOnly2 || {};
    if (input && handleInput) {
      // 移除所有绑定的事件，避免内存泄漏
      input.removeEventListener("input", handleInput);
      input.removeEventListener("compositionstart", () => { });
      input.removeEventListener("compositionend", () => { });
      input.removeEventListener("paste", () => { });
    }
    // 清理缓存属性
    delete el._numberOnly2;
  },
});
// 富文本组件
import Editor from "@/components/Editor";
import MultiVideoPreview from "@/components/VideoPreview";
Vue.component("MultiVideoPreview", MultiVideoPreview);
Vue.use(VueSignaturePad);
Vue.use(SlideVerify);
Vue.component("Editor", Editor);
import untils from "@/utils/index";
Vue.prototype.$untils = untils;
Vue.config.productionTip = false;

Vue.use(ElementUI);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
